import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import styled from "styled-components";
import { _ } from "../utils/i18n";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px 0;
  width: 100%;
  padding: 10px 0 10px 30px;
  border-left: 3px solid #f15e4e; /*theme.palette.primary.main} */
`;
const Paragraph = styled.p`  
    margin-bottom: 0;
    color: theme.palette.primary.main;
    font-family: Poppins; sans-serif;
    font-weight: 800;
    font-size: 1rem;
  `;
const Headline = styled.h4`
  margin-top: 5px;
  margin-bottom: 0;
  margin-left: 0;
  font-size: 21px;
  font-weight: 800;
  letter-spacing: 1px;
  &:hover {
    text-decoration: underline;
  }
`;
const Path = styled((props) => <Link {...props} />)`
  text-decoration: none !important;
  display: flex;
`;

const ReadMore = ({ title, uri }) => {
  return (
    <Wrapper itemScope itemType="http://schema.org/Blog">
      <Paragraph>{_("Les også")}</Paragraph>
      <Path itemProp="url" to={uri}>
        <Headline itemProp="headline">
          {title?.replace("&#8211;", "-")}
        </Headline>
      </Path>
    </Wrapper>
  );
};

ReadMore.propTypes = {
  uri: PropTypes.string,
  title: PropTypes.string,
};

ReadMore.defaultProps = {
  uri: undefined,
  title: undefined,
};

export default ReadMore;
